import { Item } from './types'

export const defaultProvideLabel = (item: Item) => item.label as string
export const defaultProvideIcon = (_item: Item) => null
export const defaultProvideKey = (item: Item) => item.id
export const emptySearchLabel = (filterValue: string) => `No match for ${filterValue}`
